import Element from "./Element";
import Leaf, { isLeaf } from "./Leaf";
import { Descendant, SlateDocument } from "./types";

export const defaultContent: SlateDocument = {
  document: {
    object: "document",
    children: [
      {
        data: {},
        object: "block",
        type: "paragraph",
        children: [
          {
            object: "text",
            text: "",
          },
        ],
      },
    ],
  },
};

export const serialize = (node, index = 0) => {
  if (isLeaf(node)) {
    const leaf = Leaf({
      leaf: node,
      children: node.text,
      attributes: "",
      key: `l-${index}`,
    });
    return leaf;
  }

  if (node.document) {
    const el = Element({
      attributes: "",
      children: node.document.children.map((n, i) => serialize(n, i)),
      element: {
        data: {},
        object: "block",
        type: "div",
      },
      key: `d-${index}`,
    });
    return el;
  }

  const el = Element({
    attributes: "",
    children: node.children.map((n, i) => serialize(n, i)),
    element: node,
    key: `e-${index}`,
  });
  return el;
};

function normalizeContent(content: Descendant[]) {
  // {"data":{},"type":"br","object":"inline","children":[]},
  return content.map(descendant => {
    if (descendant.type === "br") {
      return {
        ...descendant,
        text: "",
      };
    }
    if (descendant.object === "block" && descendant.children) {
      return {
        ...descendant,
        children: normalizeContent(descendant.children),
      };
    }
    return descendant;
  });
}

// Finds the first array of children and uses that in this document
export const parseEditorContent = editorObject => {
  let content: Descendant[];
  if (editorObject?.document) {
    content =
      editorObject.document.children || defaultContent.document.children;
  } else if (editorObject?.length > 0 && editorObject[0].children) {
    content = editorObject;
  } else {
    content = defaultContent.document.children;
  }

  return normalizeContent(content);
};
